import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, BUTTON_TYPES } from '_atoms';
import './footerButton.scss';

interface FooterButtonProps {
  onReset: () => void;
}

export const FooterButton: React.FC<FooterButtonProps> = ({ onReset }) => {
  const { t } = useTranslation();
  return (
    <div className="button-footer">
      <Button htmlType="reset" onClick={onReset}>
        {t('translation:footer_button.reset_filters')}
      </Button>
      <Button type={BUTTON_TYPES.PRIMARY} htmlType="submit">
        {t('translation:footer_button.apply')}
      </Button>
    </div>
  );
};
